import NewsletterSignUp from './NewsletterSignUp';

export default NewsletterSignUp;
